import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    CardActions,
    Button,
    Typography,
    Grid,
    Chip,
    CircularProgress,
    Divider
} from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CategoryIcon from '@mui/icons-material/Category';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { getEventsForGroup } from './apiEvents';
import { isAuthenticated } from '../auth';
import Moment from 'moment';


class PastEventList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            events: [],
            groupId: '602bbd7001dde56620236b01',  // virtual event committee
            loading: true
        };
    }

    token = isAuthenticated() && isAuthenticated().token;

    listEvents = () => {
        this.setState({ loading: true });
        getEventsForGroup(this.state.groupId, this.token).then(data => {
            if (data.error) {
                console.log(data.error);
                this.setState({ loading: false });
            } else {
                this.setState({
                    events: data,
                    loading: false
                });
            }
        });
    };

    componentDidMount() {
        this.listEvents();
    }

    getEventTypeColor = (type) => {
        const typeStr = type ? type.toLowerCase() : '';
        if (typeStr.includes('conference') || typeStr.includes('annual')) return '#FF6600';
        if (typeStr.includes('workshop')) return '#003E7E';
        if (typeStr.includes('webinar') || typeStr.includes('virtual')) return '#4caf50';
        if (typeStr.includes('training')) return '#9c27b0';
        return '#003E7E';
    };

    renderEvents = (events) => {
        if (this.state.loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <CircularProgress size={60} sx={{ color: '#003E7E', mb: 2 }} />
                        <Typography variant="h6" sx={{ color: '#003E7E' }}>Loading events...</Typography>
                    </Box>
                </Box>
            );
        }

        if (events.length === 0) {
            return (
                <Card elevation={2} sx={{ p: 5, textAlign: 'center', borderRadius: 3, backgroundColor: 'rgba(0, 62, 126, 0.02)' }}>
                    <EventIcon sx={{ fontSize: 64, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                    <Typography variant="h6" sx={{ color: '#003E7E', mb: 1 }}>
                        No Past Events
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Check back later for upcoming SDSIC events
                    </Typography>
                </Card>
            );
        }

        return (
            <Grid container spacing={3}>
                {events.map((event, i) => {
                    const eventData = event.data && event.data[0];
                    if (!eventData) return null;

                    const eventType = eventData.type || 'Event';
                    const typeColor = this.getEventTypeColor(eventType);
                    const eventDate = eventData.startDate ? Moment(eventData.startDate).format('MMMM Do YYYY') : 'Date TBD';
                    const eventTime = eventData.startDate ? Moment(eventData.startDate).format('h:mm A') : '';

                    return (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                            <Card
                                elevation={3}
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: 3,
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: `0 12px 24px ${typeColor}40`
                                    }
                                }}
                            >
                                {/* Header with Event Type */}
                                <Box
                                    sx={{
                                        p: 2,
                                        backgroundColor: typeColor,
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    }}
                                >
                                    <EventIcon sx={{ fontSize: 28 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                        {eventType}
                                    </Typography>
                                </Box>

                                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                    {/* Event Title/ID */}
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 600,
                                            color: '#003E7E',
                                            mb: 2,
                                            lineHeight: 1.3
                                        }}
                                    >
                                        {eventData.title || event._id}
                                    </Typography>

                                    <Divider sx={{ mb: 2 }} />

                                    {/* Event Details */}
                                    <Box sx={{ mb: 2 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                            <CalendarTodayIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                <strong>Date:</strong> {eventDate}
                                            </Typography>
                                        </Box>
                                        {eventTime && (
                                            <Typography variant="body2" color="text.secondary" sx={{ ml: 3.5, mb: 1.5 }}>
                                                <strong>Time:</strong> {eventTime}
                                            </Typography>
                                        )}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <CategoryIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Chip
                                                label={eventType}
                                                size="small"
                                                sx={{
                                                    backgroundColor: `${typeColor}20`,
                                                    color: typeColor,
                                                    fontWeight: 600
                                                }}
                                            />
                                        </Box>
                                    </Box>

                                    {/* Event Description if available */}
                                    {eventData.summary && (
                                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, lineHeight: 1.6 }}>
                                            {eventData.summary}
                                        </Typography>
                                    )}
                                </CardContent>

                                <CardActions sx={{ p: 2, pt: 0 }}>
                                    <Button
                                        onClick={() => window.location.href = `/showcaseEvent/${eventData._id}`}
                                        variant="contained"
                                        endIcon={<ArrowForwardIcon />}
                                        fullWidth
                                        sx={{
                                            backgroundColor: '#FF6600',
                                            '&:hover': {
                                                backgroundColor: '#e55a00'
                                            }
                                        }}
                                    >
                                        View Event
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    render() {
        const { events } = this.state;
        return (
            <Box>
                {this.renderEvents(events)}
            </Box>
        );
    }
}

export default PastEventList;